/* Dutch Line — inject wishlist hearts onto Horizon product cards */
(function () {
  function getHandle(card) {
    // Find the product URL on the card and extract the handle
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function heartSVG() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round">' +
      '<path d="M12 21l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.18L12 21z"/></svg>';
  }

  function inject(scope) {
    var cards = (scope || document).querySelectorAll('.product-card');
    cards.forEach(function (card) {
      if (card.dataset.dlHeart) return;
      var handle = getHandle(card);
      if (!handle) return;
      card.dataset.dlHeart = '1';

      // Card needs relative positioning for the absolute heart
      var media = card.querySelector('.product-card__link, .product-media, [class*="media"]') || card;
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dl-card-heart';
      btn.setAttribute('data-wishlist-toggle', handle);
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = heartSVG();
      card.appendChild(btn);
    });

    if (window.DutchlineWishlist) {
      window.DutchlineWishlist.bindButtons(scope || document);
      window.DutchlineWishlist.syncButtons();
    }
  }

  function init() { inject(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { inject(e.target); });
})();